﻿<script setup lang="ts">
    import SignedOut from '@cwd/Common/SignedOut.vue';
    import ChooseAccountList from './ChooseAccountList.vue';
    document.body.classList.add('ug-bg');
</script>
<template>
    <SignedOut>
        <h1 class="h2 m-xl-t m-xl-b">{{ $Resources.ChooseAccountHeading }}</h1>
        <p class="m-lg-b">{{ $Resources.ChooseAccountIntroduction }}</p>

        <ChooseAccountList :showPinnedAccounts="true" :pinning="'none'" :defaultDisplayMode="'default'"></ChooseAccountList>
    </SignedOut>
</template>

<style scoped></style>

<style lang="less"></style>
